import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form } from 'reactstrap';
import { hideStatusMsg } from '../../actions/FlashMessage/FlashMessages';
import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { hasAnyError, validateEmail } from '../Common/Errors/Errors';
import FlashMessages from '../Common/Messages/FlashMessages';
import { FLASH_MESSAGE } from '../../actionTypes/ErrorMessage/FlashMessage';
import Inputs from '../Common/Inputs/Inputs';
import Footer from '../Footer/Footer';
import Header from '../Headers/Header';
import SuccessResetPassword from './SuccessResetPassword';
import { setPageTitle } from '../../actions/Page/PageAction';
import { FormButtons } from '../Common';

export const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUserName] = useState('');
  const [formInputsValidation, setFormInputsValidation] = useState({});
  const [sendEmail, setSendEmail] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const [flashMsg, setFlashMsg] = useState({ ...FLASH_MESSAGE });

  const handleInputChange = (inputFields, value) => {
    setUserName(value.trim());
  };

  const backToSignIn = () => {
    navigate('/login');
  };

  const send = async () => {
    const formInputsValidation = {
      username: validateEmail(username),
    };

    // TODO: working approach using yup; need to alter the others
    // try {
    //   setFormInputsValidation({});
    //   const r = schema.validateSync(formInputsValidation);
    //   ... submit the form
    // }catch (err) {
    //   setFormInputsValidation(err);
    // }

    setFormInputsValidation(formInputsValidation);
    const hasErrors = hasAnyError(formInputsValidation);

    if (!hasErrors) {
      setIsBusy(true);
      try {
        await Auth.forgotPassword(username);
      } catch (err) {
        console.error('err');
      }
      setIsBusy(false);
      setSendEmail(true);
    }
  };

  const renderActiveForm = () => {
    return (
      <Form role='form' aria-labelledby='formTitle innerFormTitle' className="form-forget-password">
        <h2 id='innerFormTitle' className="heading-h6-nm-15">
          Can't remember your password
        </h2>
        <p className="mYSm-15">
          Enter the email address associated with your account and we will send you information about accessing
          your account.
        </p>
        <Inputs
          onInputChange={handleInputChange}
          labelSize={2}
          errorMessages={formInputsValidation.username}
          required="required"
          title="Email"
          name="username"
          placeholder="username"
          id="userEmail"
          value={username}
        />

        <FormButtons
          isBusy={isBusy}
          submitLabel='Send'
          onSubmit={send}
          extraButtonProps={{
            stretch: true,
            classNames: ['mBottom-20'],
            id: 'button-send-reset-password-link-email'
          }}
          onCancel={'/login'}
        />
      </Form>
    );
  }

  const renderCompleteBlock = () => {
    return (
      <SuccessResetPassword backToSignIn={backToSignIn} email={username} />
    );
  }

  const hideFlashMessage = () => {
    setFlashMsg({ ...FLASH_MESSAGE });
  };

  useState(() => {
    dispatch(setNavigateToMsg('Reset Password'));
    dispatch(setPageTitle('Reset Password'));
    dispatch(hideStatusMsg());
    return () => {
      dispatch(setPageTitle());
    };
  }, []);

  return (
    <React.Fragment>
      <Header />
      <main role="main" className="main-page" aria-labelledby="app_page_title">
        <div className="mobile_margin fontSm-15">
          <FlashMessages
            scope="PasswordReset"
            close={hideFlashMessage}
            type={flashMsg.msgType}
            msg={flashMsg.msg}
            open={!!flashMsg.msg}
            classNames="fl-resett-pass"
          />
          <div className="md-title">
            <h1 id="app_page_title" className="heading-h1-50">
              Reset Password
            </h1>
          </div>
          <div className="rounded-panel pSm-30">
            { sendEmail ? renderCompleteBlock() : renderActiveForm() }
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default ResetPassword;
